import * as z from 'zod';

/**
 * Restaurant category admin schemas — the category a branch belongs to.
 * Shapes mirror `apps/cpanel/openapi-eats-admin.json`
 * (`v1LocalizedRestaurantCategory`): the name rides localized, everything
 * else stays loose since only the display name is read.
 */

export const restaurantCategoryNameSchema = z
  .object({
    ru: z.string().nullish(),
    uz: z.string().nullish(),
    en: z.string().nullish(),
  })
  .loose();
export type RestaurantCategoryName = z.infer<typeof restaurantCategoryNameSchema>;

export const restaurantCategorySchema = z
  .object({
    id: z.string().nullish(),
    name: restaurantCategoryNameSchema.nullish(),
    is_active: z.boolean().nullish(),
  })
  .loose();
export type RestaurantCategory = z.infer<typeof restaurantCategorySchema>;
